import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class BaseServicesService {
  constructor() {}

  // gets whether a http or https protocol used
  private websiteProtol = window.location.href.split(':')[0];
  //private path = this.websiteProtol + '://getspos.com';
  private path = '';
  private domain = 'http://getspos.com';

  getPath() {
    const hostName = window.location.hostname;

    if (hostName != 'localhost') {
      return this.path;
    }

    return 'http://localhost:3000';
  }

  getDomain() {
    const hostName = window.location.hostname;

    if (hostName != 'localhost') {
      return this.domain;
    }

    return 'http://localhost:3000';
  }

  getPdfIconName() {
    return 'pdf.png';
  }

  getPptxIconName() {
    return 'pptx.png'
  }

  getMp3IconName() {
    return 'mp3.png'
  }
}
